import * as Headless from '@sail/theme-headless';
import {css, theme} from '../theme';

export const Icon = theme(Headless.Icon, [
  css({
    '--icon-size': css.value('16px'),
    height: css.value('var(--icon-size)'),
    width: css.value('var(--icon-size)'),

    [Headless.IconVariants.size.xxsmall]: {
      '--icon-size': css.value('8px'),
    },
    [Headless.IconVariants.size.xsmall]: {
      '--icon-size': css.value('12px'),
    },
    // No small required since it's the default
    [Headless.IconVariants.size.medium]: {
      '--icon-size': css.value('20px'),
    },
    [Headless.IconVariants.size.large]: {
      '--icon-size': css.value('32px'),
    },
    [Headless.IconVariants.size.xlarge]: {
      '--icon-size': css.value('64px'),
    },
  }),
]);
